module.exports = __webpack_public_path__ + "static/img/midfield.4933fccb.svg";